<template>
  <div :class="[{'menuContainer': true}]">
   
    <CRow class="m-0">
      <CCol col="8" v-if="index===1 || index === 2 ||index ===3">
        <div :class="[index? 'lineTop-'+index: '']" />
      </CCol>
      <CCol col="6" v-if="index===5">
        <div :class="[index? 'lineTopLeft-'+index: '']" />
      </CCol>
      <CCol col="6" v-if="index===5">
        <div :class="[index? 'lineTopRight-'+index: '']" />
      </CCol>
      <CCol col="6" v-if="index===4">
        <div :class="[index? 'lineTopLeft-'+index: '']" />
      </CCol>
    </CRow>
    <CRow :class="[index? 'animation-'+index: '']" class="m-0" v-if="index !== 5">
      <CCol sm="7" class="text-right">
        <img :src="content.image" 
              width="80%" 
              class="defaultImage" 
              :class="{ 'gray-img':!this.enableLink }"
        />
      </CCol>
      <CCol col="5" class="m-auto">
        <CRow>
          <label class="defaultTextIndex text-white">{{content.index}}</label>
          <div class="defaultText text-white">
            <CRow v-for="(text,index) in content.text" :key="index">{{text}}</CRow>
          </div>
        </CRow>
        <CRow>
          <CCol class="ml-3">
           
            <CButton
              class="btn-primary position-absolute moreDetail"
              :size="windowWidth>769?'lg':'sm'"
              :disabled="!enableLink"
              @click="routeToPreview(content.button.action)"
            >{{$helpers.translate(content.button.text, lang)}}</CButton>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow :class="[index? 'animation-'+index: '']" class="m-0" v-if="index === 5">
      <CCol col="7" class="text-right">
        <img :src="content.image" 
             width="80%" 
             class="defaultImage" 
             :class="{ 'gray-img':!this.enableLink }"
        />
      </CCol>
      <CCol col="5" class="m-auto">
        <CRow>
          <label class="defaultTextIndex text-white">{{content.index}}</label>
          <div class="defaultText text-white">
            <CRow v-for="(text,index) in content.text" :key="index">{{text}}</CRow>
          </div>
        </CRow>
        <CRow>
          <CCol>
            <CButton
              class="btn-primary position-absolute moreDetail"
              :size="windowWidth>769?'lg':'sm'"
              :disabled="!enableLink"
              @click="routeToPreview(content.button.action)"
            >{{$helpers.translate(content.button.text, lang)}}</CButton>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <div v-if="index===1 || index === 2" :class="[index? 'lineDown-'+index: '']" />
    <CRow v-if="index===3 || index=== 4 || index === 5" class="m-0">
      <CCol>
        <div :class="[index? 'lineBottomLeft-'+index: '']" />
      </CCol>
      <CCol>
        <div :class="[index? 'lineBottomRight-'+index: '']" />
      </CCol>
    </CRow>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      lang: "th",
      //enableLink: false,
      enableLink: true,
      windowWidth: window.innerWidth,
      contentProgress: []
    }
  },
  props: {
    content: Object,
    index: Number,
    progress: Object
  },
  watch: {
    progress: function(val){
      var countProgress = 0
      this.contentProgress = val.filter((p) => {
        if(this.content.name == this.$helpers.translate(p.description, this.lang)){
          return p;
        }
      })
      this.enableLink = !this.contentProgress[0].lock;
    }
  },
  methods: {
    routeToPreview(action) {
      this.$emit("routePreview", action);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/CPR/menu"; //@import "../../assets/scss/menu";
.btn-primary:disabled{
  border-color: #999;
  box-shadow: none !important;
  pointer-events: none;
}
</style>